import AuthLayout from "components/layouts/AuthLayout";

import LoginForm from "./LoginForm";

const LoginPage = () => {
  return (
    <AuthLayout
      title="Sign In"
      subtitle="Enter your credentials to access your account."
      footerLink={{ label: "Forgot your password?", to: "/forgot-password" }}
    >
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
